/* ProgressRenderer.js */

"use strict";
const Loader = require("@gluenetworks/fancy_loading_mask_gl");
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;

/**
 *
 * @class ProgressRenderer
 *
 * @listens ProgressComponent#event:Progress
 */

class ProgressRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = this._createRootElement();
        this._rootElem.component = this._model;

        this._loader = new Loader({
            darkTheme: true,
            shown: true,
            message: this._model._message,
        });

        this._hideButton = new ButtonControl({
            label: "Hide",
            darkTheme: true,
        });

        this._registerListeners();
        this.render();
    }

    get rootElement() {
        return this.getRootElement();
    }

    get model() {
        return this.getModel();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._model.on("Progress", (this._onProgress = this._onProgress.bind(this)));
        this._hideButton.on(
            "UserClick",
            (this._onHideButtonClick = this._onHideButtonClick.bind(this))
        );
    }

    _unregisterListeners() {
        this._model.removeListener("Progress", this._onProgress);
        this._hideButton.removeListener("UserClick", this._onHideButtonClick);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        this._rootElem.remove();

        return Promise.all([this._loader.shutdown(), this._hideButton.shutdown()]).then(
            () => {
                this._model = undefined;
                this._rootElem = undefined;
                this._loader = undefined;
                this._hideButton = undefined;
            },
            (/*err*/) => {}
        );
    }

    render() {
        this._rootElem.innerHTML = "";
        const root = document.createDocumentFragment();

        const loaderContainer = document.createElement("div");
        loaderContainer.className = "loader-container";
        loaderContainer.appendChild(this._loader.renderer.rootElement);
        root.appendChild(loaderContainer);

        const buttonContainer = document.createElement("div");
        buttonContainer.className = "actions_container";
        buttonContainer.appendChild(this._hideButton.renderer.rootElement);
        root.appendChild(buttonContainer);

        this._rootElem.appendChild(root);
        return new Promise((resolve /*,reject*/) => {
            resolve();
        });
    }

    getRootElement() {
        return this._rootElem;
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    _createRootElement() {
        const rootElement = document.createElement("div");
        rootElement.classList.add("run-template-progress", "modal_feedback_container");
        rootElement.component = this._model;
        return rootElement;
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onProgress(msg) {
        if (this._loader) {
            this._loader.showProgress(msg);
        }
    }

    _onAbortButtonClick() {
        this._model.abortProgress();
    }

    _onHideButtonClick() {
        this._model.close();
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}
module.exports = ProgressRenderer;
